import { useTranslation } from 'react-i18next';
import { CrmSignupCard } from './CrmSignupCard';
import { CrmIntegratedManagement } from './CrmIntegratedManagement';
import { CrmManagement } from './CrmManagement';

type CrmDetailFeature = { title: string; description: string };

// Same alternating layout the CRM page uses for its four sections.
const featureIcons = [undefined, 'attendance', 'recruitment', undefined] as const;

export default function CrmDetailContent({ detailKey }: { detailKey: string }) {
    const { t } = useTranslation();

    const overview = t(`crmPage.details.${detailKey}.overview`, { defaultValue: '' });
    const features = t(`crmPage.details.${detailKey}.features`, {
        returnObjects: true,
        defaultValue: [],
    }) as CrmDetailFeature[];

    return (
        <div className="mt-[86px] mainContainer">
            {overview && (
                <p className="mb-6 text-primary-text/90 font-medium sm:text-base text-[15px] lg:text-[20px] leading-relaxed">
                    {overview}
                </p>
            )}

            <div className="flex flex-col gap-10">
                {features.map((feature, index) => {
                    const icon = featureIcons[index % featureIcons.length];
                    const Section = index % 2 === 0 ? CrmManagement : CrmIntegratedManagement;
                    return (
                        <Section
                            key={feature.title}
                            icon={icon}
                            title={feature.title}
                            description={feature.description}
                        />
                    );
                })}
            </div>

            <CrmSignupCard />
        </div>
    );
}
